@import "~@uipath/apollo-core/src/scss/base-host.scss";

button {
  font-size: 100%;
  font-family: inherit;
  border: 0;
  padding: 0;
  background-color: transparent;
}

.pt-app-bar {
  display: flex;
  height: 48px;
  flex-direction: row;
  border-bottom: 1px solid var(--color-border-de-emp);
  background-color: var(--color-background);
  align-items: center;
  box-sizing: border-box;
  .co-brand {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      padding-top: $pad-xs;
      max-height: 18px;
      width: auto;
      height: auto;
      max-width: 150px;
    }
  }
}

::slotted([slot="waffle-menu"]) {
  padding-left: 17.5px;
  padding-right: 17.5px;
  border-right: 1px solid var(--color-border-de-emp);
  max-height: 29px;
}

.header {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  padding-left: 24px;
  align-items: center;
  font-family: $font-normal;
}

.logo {
  margin-right: 5px;
  line-height: 0px;
  width: auto;
  cursor: pointer;
  display: flex;
  align-items: center;
  outline-offset: 6px;
  text-decoration: none;

  .svg-logo-path {
    fill: var(--color-logo);
  }

  .product {
    font-size: 16px;
    font-weight: 600;
    line-height: $font-l-line-height;
    font-family: $font-title;
    letter-spacing: -0.033em;
    color: var(--color-foreground-emp);
    overflow: visible;
    margin-top: $pad-xs;
  }

  .logo-container {
    display: flex;
    justify-content: center;
  }

  .with-product {
    margin-right: $pad-l;
  }
}

.pt-trademark {
  font-size: 5px;
  margin-bottom: 15px;
  color: var(--color-foreground);
}

.pt-divider {
  height: 40px;
  border-left: 2px solid var(--color-border-de-emp);
  padding-right: 20px;
  margin-left: 20px;
}

.preview-tag {
  font-family: $font-normal;
  font-style: normal;
  height: 16px;
  font-weight: 400;
  font-size: $font-xs-size;
  line-height: $font-m-line-height;
  color: var(--color-foreground-de-emp);
  display: flex;
  width: auto;
  align-items: center;
  outline-offset: 2px;
  margin-left: $pad-xxl;
  margin-top: 2px;
}

.feature {
  font-family: $font-normal;
  font-style: normal;
  height: 23px;
  font-weight: 600;
  font-size: $font-m-size;
  line-height: $font-m-line-height;
  color: var(--color-foreground);
  display: flex;
  width: auto;
  align-items: center;
  cursor: pointer;
  outline-offset: 2px;
  margin-top: 2px;
  text-decoration: none;
}

.slot-end {
  display: flex;
  flex-direction: row;
  margin-right: 24px;
  align-items: center;
  padding-top: 2px;
}

::slotted([slot="slot-mid"]) {
  display: flex;
  flex-grow: 1;
  justify-content: flex-start;
}

::slotted([slot="slot-start"]) {
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview {
  font-family: $font-normal;
  padding: 0;
  color: var(--color-foreground-de-emp);
  margin: 0;
  font-weight: normal;
  font-size: $font-xs-size;
  height: 16px;
  line-height: $font-s-line-height;
  position: absolute;
  left: 0;
  top: 100%;
}

.tenant-picker-dropdown {
  margin-left: 20px;
}

.pt-app-bar.redesign {
  ::slotted([slot="waffle-menu"]) {
    border-right: unset;
    margin-right: -24px;
  }
}

::slotted([slot="profile-menu"]) {
  margin-left: $pad-xxxl;
}
